<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
		<g :fill="color">
			<path :fill="color" d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z"/>
			<path :fill="secondaryColor" d="M15.69,15.3544022 C16.0652242,15.6937405 16.105458,16.2858489 15.7798647,16.6769132 C15.4542714,17.0679776 14.8861466,17.1099099 14.5109224,16.7705716 L10.3099897,12.9714101 C9.91424265,12.6135117 9.89458687,11.9802381 10.2673126,11.5964312 L14.4682453,7.27060461 C14.821642,6.90670138 15.3911793,6.9102782 15.7403425,7.27859366 C16.0895058,7.64690912 16.0860738,8.24048965 15.7326771,8.60439287 L12.2227062,12.2187154 L15.69,15.3544022 Z" transform="rotate(-179 13 12)"/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'arrow-right',
	props: {
		color: {
			default: '',
			type: String,
		},

		secondaryColor: {
			default: '#FFF',
			type: String,
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/svg/ArrowRight.vue